import { FullScreenToggler } from '@gogame/data-grid';
import { ActionBar, Actions, Action, Tabs, Tab } from '@gogame/components';
import MetricsPicker, { getOptionValue } from './MetricsPicker';
import Sorting from './Sorting';
import { SearchField } from '@gogame/screens';
import React, { useMemo } from 'react';
import { useScreenState, useScreenDispatch } from '@gogame/screens';
import { useLoadMetrics } from '../../data';

import { SET_DIMENSION, SET_METRICS, SET_TABLE_SETTINGS } from '../../reducers';

const EMPTY_ARR = [];

const CreativesTrackerToolbar = ({ dimensions }) => {
  const screenState = useScreenState();
  const dispatch = useScreenDispatch();
  const { tableSettings, dimension, temporary } = screenState;

  const metrics = temporary?.metrics || screenState?.metrics || EMPTY_ARR;
  const { data: metricOptions = EMPTY_ARR } = useLoadMetrics();

  const handleChangeMetrics = (newValue) => {
    dispatch({
      type: SET_METRICS,
      payload: newValue.map(getOptionValue),
    });
  };

  const selectedMetrics = useMemo(() => {
    if (!metricOptions?.length) {
      return EMPTY_ARR;
    }

    return metrics.map((id) =>
      metricOptions.find((opt) => getOptionValue(opt) === id)
    );
  }, [metrics, metricOptions]);

  const handleSort = (orderBy, orderDir) => {
    dispatch({
      type: SET_TABLE_SETTINGS,
      payload: { orderBy, orderDir },
    });
  };

  const handleTabChange = (_e, newActiveTabId) => {
    dispatch({
      type: SET_DIMENSION,
      payload: newActiveTabId,
    });
  };

  return (
    <ActionBar
      tabs={
        <Tabs value={dimension} onChange={handleTabChange}>
          {dimensions?.map(({ id, name }) => {
            return <Tab value={id} label={name} data-cy-label={name} />;
          })}
        </Tabs>
      }
      search={<SearchField tooltip={'Search by name'} />}
      primaryActions={
        <Actions>
          <Action
            component={Sorting}
            componentProps={{
              options: selectedMetrics,
              orderDir: tableSettings.orderDir,
              orderBy: tableSettings.orderBy,
              onChange: handleSort,
            }}
          />
          <Action
            component={MetricsPicker}
            componentProps={{
              options: metricOptions,
              selectedOptions: selectedMetrics,
              onChange: handleChangeMetrics,
            }}
          />
          <Action component={FullScreenToggler} />
        </Actions>
      }
    />
  );
};

export default CreativesTrackerToolbar;
